import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "VA Community Care Network (CCN)",
  shortName: "VA CCN",
  slug: "va-ccn-insurance",
  seoTitle: "VA Community Care Network (CCN) TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Are you a Veteran with VA CCN benefits? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through the VA Community Care Network in Coral Springs, FL.",
  seoKeywords:
    "VA CCN TMS coverage, VA Community Care Network TMS therapy, VA CCN depression treatment Florida, VA mental health benefits Coral Springs FL, VA CCN SAINT TMS, Veterans TMS treatment",
  planType: "federal community care pathway for Veterans",
  planRegion: "nationwide (Regions 1–4)",
  memberTerm: "Veterans",
  behavioralHealthTerm:
    "mental health benefits available through VA community care",
  planSpecificIntro:
    "The VA Community Care Network (CCN) is the Department of Veterans Affairs' direct link to community providers, allowing Veterans to receive care from non-VA providers when VA facilities cannot provide the needed service or when it is in the Veteran's best interest. Through CCN, Veterans may be able to access TMS therapy, accelerated TMS protocols, and other advanced depression treatments at community providers like Neuro Wellness TMS. Authorization through the VA is required, and coverage depends on clinical necessity, VA referral approval, and the specific CCN region's policies.",
  officialResourceUrl: "https://www.va.gov/COMMUNITYCARE/",
  officialResourceLabel: "VA Community Care official website",
  faqs: [
    {
      question: "Does the VA CCN cover TMS therapy?",
      answer:
        "The VA Community Care Network may cover TMS therapy when it is authorized through a VA referral and deemed medically necessary. Veterans must obtain approval from their VA care team before receiving TMS through a community provider. Our team can help you understand the authorization process.",
    },
    {
      question: "How do I get a VA referral for TMS treatment?",
      answer:
        "Speak with your VA primary care provider or mental health provider about a referral to community care. They will determine whether TMS is appropriate and whether community care is the right pathway. Our team can provide documentation to support the referral request.",
    },
    {
      question: "Can I receive SAINT through the VA CCN?",
      answer:
        "SAINT may be available through the VA Community Care Network if authorized by your VA care team. Because SAINT is an accelerated protocol with Category III billing codes, authorization depends on clinical necessity and your specific CCN region's policies. Our team can help you understand the process.",
    },
    {
      question: "Do I need prior authorization from the VA?",
      answer:
        "Yes. The VA requires authorization before you receive care through the Community Care Network. Your VA provider must approve the referral, and the CCN third-party administrator must authorize the services. Our team can assist with the documentation needed.",
    },
    {
      question: "Do I need to have tried medication first?",
      answer:
        "The VA typically requires documentation of adequate trials of evidence-based treatments, including antidepressant medications and psychotherapy, before authorizing advanced neuromodulation treatments like TMS. Our team can review your situation and explain what information may be needed.",
    },
    {
      question: "Do I have to travel to Florida for treatment?",
      answer:
        "Neuro Wellness TMS is located in Coral Springs, Florida. Veterans who receive authorization through the VA CCN may travel to our center for treatment, particularly for accelerated protocols like SAINT. Our team can discuss travel logistics and available options.",
    },
    {
      question: "How do I get started with VA CCN treatment?",
      answer:
        "Complete the insurance verification form on this page or call us at (954) 827-9793. Our team will help you understand the VA CCN authorization process and what documentation may be needed to support your referral.",
    },
    {
      question: "What if my VA facility offers TMS already?",
      answer:
        "If your VA facility offers TMS, the VA may prefer that you receive treatment there. However, if wait times are long, the specific protocol you need is not available, or it is in your best clinical interest, community care through CCN may be an option. Discuss this with your VA care team.",
    },
  ],
};

export const VaCcnInsurance = () => <InsurancePageTemplate config={config} />;
export default VaCcnInsurance;
